import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDPMc6Brw1RmILcLFJ4lwN0EMQ6lk95n4M",
  authDomain: "ofta-1c368.firebaseapp.com",
  projectId: "ofta-1c368",
  storageBucket: "ofta-1c368.firebasestorage.app",
  messagingSenderId: "615085995916",
  appId: "1:615085995916:web:06d9d071caf74100f548a9",
  measurementId: "G-W544X9B1LQ"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
